// extracted by mini-css-extract-plugin
export default {"container":"EmptyPage_container__97DzT"};